import React, { useCallback, useEffect, useRef, useState } from "react";
import imageStyle from "../component/imageSwiper.module.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Autoplay, Navigation, Pagination } from "swiper";
import Images from "./Images";
import image3Sm from "../assets/soyf-reg-banner@sm.webp";
import { useMediaQuery } from "../hooks/useMediaQuery";
import useIntersection from "../hooks/useIntersection";

const onSlideChange = (swiper) => {
  console.log({ swiper });
};

const CustomVideoPlayer = ({ src, isActive = false }) => {
  const videoEl = useRef(null)
  useEffect(() => {
    if (!isActive) {
      videoEl?.current?.pause()
    } else {
      videoEl?.current?.play()
    }
  }, [isActive])
  return (
    <div className="w-full">
      <video ref={videoEl} controls src={src} autoPlay={isActive} playsInline width={'100%'} className="desktop-video-2" frameborder="0" />
    </div>
  )
}

const BannerSwiper = ({ executeScroll }) => {
  const sliderRef = useRef(null);
  const isMobile = useMediaQuery();
  const inViewport = useIntersection(sliderRef, "0px");
  console.log({ isMobile });
  return (
    <section className={imageStyle.sliderSection}>
      <div className="mb-4 container-fluid">
        <Swiper
          id="imageSwiper"
          ref={sliderRef}
          modules={[Navigation, Pagination]}
          loop={true}
          autoplay={false}
          autoHeight={false}
          slidesPerView={1}
          pagination={{
            clickable: true, // Enable clickable pagination bullets
            // el: ".swiper-pagination", // Element to render pagination bullets
          }}
          navigation={true}
          spaceBetween={20}
          className={imageStyle.mySwiper2}
        // onSlideChange={onSlideChange}
        >
          <SwiperSlide>
            {({ isActive }) => (
              <>
                <div className="h-100 cursor-pointer" onClick={executeScroll}>
                  <picture className="w-100">
                    <source srcSet={'https://moha-m.b-cdn.net/media/uploads/winners-2024-potrait.webp'} media="(max-width: 700px)" />
                    <img
                      src={'https://moha-m.b-cdn.net/media/uploads/winners-2024@lg.webp'}
                      style={imageStyle}
                      alt="Registration CTA"
                    />
                  </picture>
                </div>
              </>
            )}
          </SwiperSlide>
          <SwiperSlide>
            {({ isActive }) => (
              <>
                <div className="h-100 cursor-pointer" onClick={executeScroll}>
                  <picture className="w-100">
                    <source srcSet={'https://moha-m.b-cdn.net/media/soyf/Soyf_registration_New-mobile-banner.webp'} media="(max-width: 700px)" />
                    <img
                      src={'https://moha-m.b-cdn.net/media/soyf/Soyf_registration_New_web-banner.webp'}
                      style={imageStyle}
                      alt="Registration CTA"
                    />
                  </picture>
                </div>
              </>
            )}
          </SwiperSlide>

          <SwiperSlide className="">
            {({ isActive }) => (
              <>
                <iframe
                  src={`https://iframe.mediadelivery.net/embed/298375/${isMobile ? 'c424183f-25b6-4080-87f9-0b4fd6632bbf' : 'e66506a9-d513-42ed-8c5a-9d9c7c10158d'}?muted=true&autoplay=${isActive && inViewport ? 'true' : "false"
                    }`}
                  className={isMobile ? 'mobile-video' : "desktop-video-2"}
                  loading="lazy"
                  width="100%"
                  title="Charak"
                  allowfullscreen="true"
                  allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"></iframe>
                <div className="iframe-overlay"></div>
              </>
            )}
          </SwiperSlide>
          <SwiperSlide>
            {({ isActive }) => (
              <>
                <iframe
                  src={`https://iframe.mediadelivery.net/embed/298375/${isMobile ? '8bb29763-b0d7-4fe6-8b11-4e4626bb2579' : '3690c264-9244-426c-aca4-c3273ec7b942'}?muted=true&autoplay=${isActive && inViewport ? 'true' : "false"
                    }`}
                  className={isMobile ? 'mobile-video' : "desktop-video-2"}
                  loading="lazy"
                  width="100%"
                  title="Charak"
                  allowfullscreen="true"
                  allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"></iframe>
                <div className="iframe-overlay"></div>
              </>
            )}
          </SwiperSlide>
          <SwiperSlide>
            {({ isActive }) => (
              <>
                {/* <iframe
                  className="desktop-video-2"
                  width="100%"
                  src={`https://www.youtube.com/embed/5dHwEPXaBnY?autoplay=${
                    isActive && inViewport ? 1 : 0
                  }&rel=0&loop=1&playlist=5dHwEPXaBnY`}
                  title="Registration"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe> */}
                {/* <iframe className="desktop-video-2"
                  width="100%" src="https://drive.google.com/file/d/1hKq2WBwvnHGyq9LVLS9BQj8qWGFSlZxE/preview" allow="autoplay" frameborder="0"
                  allowfullscreen></iframe> */}
                {/* <CustomVideoPlayer 
                    src="https://vz-1e704e21-604.b-cdn.net/506e8ae2-9073-4cbd-86bd-b3eda46c8038/play_720p.mp4" isActive={isActive} /> */}
                <iframe
                  src={`https://iframe.mediadelivery.net/embed/298375/${isMobile ? '506e8ae2-9073-4cbd-86bd-b3eda46c8038' : '16399649-650e-499f-ad98-b42e792e53fa'}?autoplay=${isActive && inViewport ? 'true' : "false"
                    }`}
                  className={isMobile ? 'mobile-video' : "desktop-video-2"}
                  loading="lazy"
                  width="100%"
                  title="Charak"
                  allowfullscreen="true"
                  allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"></iframe>
                <div className="iframe-overlay"></div>

              </>
            )}
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  );
};

export default BannerSwiper;
